import {
    REGION_DROPDOWN_BUTTON_TEST_ID,
    REGION_DROPDOWN_TEST_ID,
} from "@e2e/helpers/checkout/components/shipping-details/constants";
import { Address, CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { H } from "@ecco/ui/a11y-heading";
import { Text } from "@ecco/ui/text";
import { Button } from "@ecco/ui/button";
import { Flex } from "@ecco/ui/flex";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import {
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
} from "@ecco/ui/modal";
import { useState } from "react";
import type { CountryCode } from "@config/site/types";
import { styles } from "./selector.styles";

interface Props {
    title: string;
    selectMenuTitle: string;
    onClose: () => void;
    isError?: boolean;
    preOpen?: boolean;
    field?: string;
    isReadOnly?: boolean;
    styleButton?: object;
    setFieldValue?: (field: string, state: string) => void;
    country: CountryCode;
    locale: string;
    testId?: string;
    items: any[];
}

export type SelectType = {
    name: string;
    value: string;
};

export const Selector = ({
    isError = false,
    preOpen = false,
    title,
    isReadOnly,
    field,
    styleButton,
    testId,
    setFieldValue,
    items,
}: Props) => {
    const [isOpen, setIsOpen] = useState(preOpen);
    const { get: getMicrocopy } = useMicrocopy();
    const handleClose = (field?: string, item?: SelectType) => {
        if (item) {
            setFieldValue(field, item.value);
            setIsOpen(!isOpen);
            return;
        }

        setIsOpen(!isOpen);
    };

    return (
        <>
            <Button
                data-testid={testId}
                variant={"outline"}
                sx={styleButton ?? styles.button}
                colorScheme={isError ? "red" : "gray"}
                bg={"white"}
                justifyContent={"space-between"}
                isDisabled={isReadOnly}
                rightIcon={
                    isOpen ? (
                        <ECCOIcon transform={"rotate(180deg)"} name="chevron" alignSelf={"end"} />
                    ) : (
                        <ECCOIcon name="chevron" alignSelf={"end"} />
                    )
                }
                onClick={() => setIsOpen(!isOpen)}
            >
                <Text fontSize={["mobileBodyTextTiny"]} fontWeight={"bold"}>
                    {title}
                </Text>
            </Button>
            <Modal
                trapFocus={false}
                initialFocusRef={null}
                onClose={() => handleClose()}
                isOpen={isOpen}
                size="full"
            >
                <ModalOverlay />
                <ModalContent sx={styles.modalContent} height="100vh !important">
                    <ModalHeader>
                        <ModalCloseButton onClick={() => handleClose()} />
                    </ModalHeader>
                    <ModalBody data-testid={REGION_DROPDOWN_TEST_ID}>
                        <H size="h3" textAlign="center">
                            {getMicrocopy(CommonCMS.page, Address.form.placeholderDropdown)}
                        </H>
                        <Flex sx={styles.wrapContainer}>
                            {items.map((item) => {
                                return (
                                    <Button
                                        data-testid={REGION_DROPDOWN_BUTTON_TEST_ID}
                                        onClick={() => handleClose(field, item)}
                                        key={item.name}
                                        sx={styles.wrapItem}
                                        variant={"outline"}
                                    >
                                        {item.name}
                                    </Button>
                                );
                            })}
                        </Flex>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};

export default Selector;
